module.exports = __webpack_public_path__ + "static/media/logo.fc570556.fc570556.svg";